<div class="row">
  <div class="col-md-8 col-sm-12">
    <form novalidate #serviceRequestForm="ngForm">
      <div class="container-fluid">
        <!--wizard icons-->
        <div class="row">
          <div class="col-md-12">
            <app-card hideHeader>
              <div class="container">
                <div class="row">
                  <div class="col-4 text-center step" [ngClass]="{active: step === 1, disabled: step > 1}">
                    <div class="step-circle">1</div>
                    {{'admin.backoffice.order.information' | translate}}
                  </div>
                  <div class="col-4 text-center step" [ngClass]="{active: step === 2, disabled: step > 2}">
                    <div class="step-circle">2</div>
                    {{'admin.service_request.service_information' | translate}}
                  </div>
                  <div class="col-4 text-center step" [ngClass]="{active: step === 3}">
                    <div class="step-circle">3</div>
                    {{'admin.service_request.check_and_submit' | translate}}
                  </div>
                </div>
              </div>
            </app-card>
          </div>
        </div>
        <!--end wizard icons-->
        <!--first step-->
        <section *ngIf="step===1">
          <div class="row">
            <div class="col-md-12">
              <app-card [title]="('admin.backoffice.order.information'|translate)">
                <div class="form-group">
                  <div class="container">
                    <div class="">
                      <div class="row">
                        <label class="col-sm-3 col-form-label no-padding-right left-pos">
                       <span class="labelWithToolTip no-padding-y">
                          {{'doctrine.attributes.order'|translate}}<span class="star">*</span>
                       </span>
                          <span class="tooltip-item ">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'doctrine.order.select_order'|translate}}
                          </div>
                        </ng-container>
                        </span>
                    </span>
                        </label>
                        <div class="col-sm-9">
                          <ng-select #orderNumber="ngModel" name="orderNumber"
                                     [items]="selectedOrders"
                                     [required]="true"
                                     [(ngModel)]="order.id"
                                     (change)="changeOrder($event)"
                                     (ngModelChange)="formValidateCheck()"
                                     bindLabel="label"
                                     bindValue="value"
                                     placeholder="{{'global.search'|translate}} {{'doctrine.order.number'|translate}}"
                                     [clearable]="false"
                                     [disabled]="orderIsSelected"
                                     autofocus
                                     [typeahead]="ordersTypeahead">
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled text-black-50">
                                {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
                              </div>
                            </ng-template>
                            <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled text-black-50">
                                {{'doctrine.order.search_for'|translate}} {{searchTerm}}
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-card>
            </div>
          </div>
          <div class="row" *ngIf='order.reference'>
            <div class="col-md-12">
              <app-card [title]="('admin.dealer.order.choose_article'|translate)">
                <div class="form-group">
                  <div class="container">
                    <div class="">
                      <div class="row">
                        <label class="col-sm-3 col-form-label no-padding-right left-pos">
                       <span class="labelWithToolTip no-padding-y">
                          {{'doctrine.backoffice.order.article'|translate}}<span class="star">*</span>
                       </span>
                          <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'doctrine.order.select_article'|translate}}
                          </div>
                        </ng-container>
                        </span>
                    </span>
                        </label>
                        <div class="col-sm-9">
                          <ng-select #article="ngModel" name="article"
                                     [items]="orderArticles"
                                     [required]="true"
                                     [(ngModel)]="selectedArticle"
                                     (change)="changeArticle($event)"
                                     (ngModelChange)="formValidateCheck()"
                                     bindLabel="label"
                                     bindValue="value"
                                     placeholder="{{'global.search'|translate}} {{'doctrine.backoffice.order.article'|translate}}"
                                     [clearable]="false"
                                     autofocus>
                            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled text-black-50">
                                {{'doctrine.order.no_result_found_for'|translate}} {{searchTerm}}
                              </div>
                            </ng-template>
                            <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
                              <div class="ng-option disabled text-black-50">
                                {{'doctrine.order.search_for'|translate}} {{searchTerm}}
                              </div>
                            </ng-template>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </app-card>
            </div>
          </div>
          <div class="row" *ngIf='order.reference && selectedArticle'>
            <div class="col-md-12">
              <app-card [customTitle]="customTitle">
                <ng-template #customTitle>
                  <input
                    type="checkbox"
                    name='articleCheckbox'
                    (change)="wholeArticle($event.target.checked)"
                    style="margin-right:10px"
                    [checked]="!elementSelection"
                  >
                  <h5 class="d-flex align-items-center">{{ ('doctrine.backoffice.order.article'|translate) }}</h5>
                </ng-template>
                <!-- Details for collection
                ------------------------->
                <div class="form-group ">
                  <div class="container">
                    <div class="card-align">
                      <div class="row">
                        <label class="col-sm-4 col-form-label no-padding left-pos">
                          <span class="labelWithToolTip"> {{'doctrine.attributes.collection'|translate}}</span>
                        </label>
                        <div class="col-sm-6 ">
                          <p class="field-place">
                            {{ orderItem.collection.name}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Details for model
                --------------------->
                <div class="form-group ">
                  <div class="container">
                    <div class="card-align">
                      <div class="row">
                        <label class="col-sm-4 col-form-label no-padding left-pos">
                          <span class="labelWithToolTip">  {{'doctrine.attributes.model'|translate}}</span>
                        </label>
                        <div class="col-sm-6">
                          <p class="field-place">
                            <span> {{ orderItem.model.name}}</span>
                            <span *ngIf="orderItem.style!==null">,{{ orderItem.style.name}}</span>

                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--
                ======================================================
                # Products (Products/Elements of an Article) - [start]
                ======================================================
                -->
                <ng-container *ngFor="let productItem of orderItem.orderItemProducts;let j=index;">
                  <div *ngIf="elementSelection" class="mb-2 container">
                    <div class="row">
                      <div class="col-lg-6">
                        <input
                          type="checkbox"
                          name='productItem'
                          (change)="changeElement($event , productItem.id)"
                          style="margin-right:10px"
                        >
                        <strong>{{'admin.order.element'|translate}} {{orderItemCount(j)}}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <!--insert product col-->
                    <div class="mb-4 mt-4 bg-light text-dark">
                      <div class="card-body fabrics">
                        <div class="container">
                          <!--form with  with img  -->
                          <div class="row">
                            <!--form-box-->
                            <div class=" col-md-10 col-sm-8 no-padding-left">
                              <div class="form-group ">
                                <div class="container">
                                  <div class="row">
                                    <label class="col-sm-5 col-form-label no-padding-left left-pos">
                                  <span class="labelWithToolTip">
                                        {{'doctrine.attributes.product'|translate}}
                                  </span>

                                    </label>
                                    <div class="col-sm-7  no-padding ">
                                      <div class="row">
                                        <div class="col-sm-1">
                                          <p class="field-place">
                                            {{ productItem.amount}}
                                          </p>
                                        </div>
                                        <div class="col-sm-11">
                                          <p class="field-place">
                                      <span>
                                          {{ productItem.product.name }}
                                      </span>
                                          </p>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Fabric -------------------------------------------------------->
                              <div class="form-group"
                                   *ngIf="productItem.orderItemProductFabricCollections.length !== 0 && checkHasFabric(productItem.orderItemProductFabricCollections[0])">
                                <div class="container">
                                  <div class="row">
                                    <label class="col-form-label col-sm-5 no-padding-left left-pos">
                                  <span class="labelWithToolTip">{{'doctrine.attributes.fabric'|translate}}
                                  </span>

                                    </label>
                                    <!-- Fabric collection, Fabric, Fabric color (with image)
                                    -------------------------------------------------------->
                                    <div class="col-sm-7 no-padding">
                                      <div class="row"
                                           *ngFor="let fabricItem of productItem.orderItemProductFabricCollections">
                                        <div class="col-sm-12" *ngIf="fabricItem.fabricCollection">
                                          <p class="field-place">
                                            {{ (fabricItem.fabricCollection.name) + ' , ' + (fabricItem.fabric.name) + ' , ' + (fabricItem.fabricColor.name) }}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Carpets & Rugs — a rug has no fabric, so show the size and the
                                   shape / finishing / colour that identify it instead (D9) ------->
                              <ng-container *ngIf="isRugProduct(productItem)">
                                <div class="form-group"
                                     *ngIf="carpetSizeLabel(productItem.widthCm, productItem.lengthCm) as sizeLabel">
                                  <div class="container">
                                    <div class="row">
                                      <label class="col-form-label col-sm-5 no-padding-left left-pos">
                                        <span class="labelWithToolTip">{{'admin.dealer.order.carpet_size'|translate}}</span>
                                      </label>
                                      <div class="col-sm-7 no-padding">
                                        <p class="field-place">{{sizeLabel}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group"
                                     *ngFor="let role of [CARPET_ROLE_SHAPE, CARPET_ROLE_FINISHING, CARPET_ROLE_COLOUR]">
                                  <div class="container" *ngIf="rugOptionName(orderItem, productItem, role) as optionName">
                                    <div class="row">
                                      <label class="col-form-label col-sm-5 no-padding-left left-pos">
                                        <span class="labelWithToolTip">{{carpetRoleLabelKey(role)|translate}}</span>
                                      </label>
                                      <div class="col-sm-7 no-padding">
                                        <p class="field-place">{{optionName}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>

                              <!-- Product packages ----------------------------------------------->
                              <div *ngIf="productItem.orderItemProductPackages.length !== 0">
                                <div class="container">
                                  <div class="row" *ngFor="let packageProduct of productItem.orderItemProductPackages">
                                    <label class="col-form-label col-sm-5 no-padding-left left-pos form-group"
                                           *ngIf="packageProduct.orderItemProductPackageProducts[0]">
                                    <span class="labelWithToolTip">
                                      {{packageProduct.package.name}}
                                    </span>
                                    </label>
                                    <div class="col-sm-7 no-padding"
                                         *ngIf="packageProduct.orderItemProductPackageProducts[0] && packageProduct.orderItemProductPackageProducts[0].product">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <p class="field-place">
                                            {{packageProduct.orderItemProductPackageProducts[0].product.name}}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- End of product packages ----------------------------------------------->

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
                <!--end-->
              </app-card>
            </div>
          </div>
        </section>
        <!--end first step-->
        <!--second step-->
        <section *ngIf="step===2">
          <div class="row">
            <div class="col-md-12" *ngIf="!serviceSubjectQueue.length">
              <app-card [title]="('admin.service_request.service_subject.title'|translate)">
                <div class="container">
                  <p>{{'admin.service_request.service_subject.text'|translate}}</p>
                  <button class="btn btn-subject"
                          [class.btn-active]="serviceSubjectItemActive?.id === setServiceSubject(serviceSubject)?.id"
                          *ngFor="let serviceSubject of serviceSubjectList"
                          (click)="serviceSubjectItemActive = setServiceSubject(serviceSubject)"
                  >
                    {{serviceSubject.name}}
                  </button>
                </div>
              </app-card>
            </div>
            <div class="col-md-12" *ngIf="serviceSubjectQueue.length">
              <app-card [title]="serviceSubjectQueue[serviceSubjectQueue.length - 1].name">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-3">
                      <img
                        src="{{baseUrl + '/download?path=' +
                    serviceSubjectQueue[serviceSubjectQueue.length - 1].thumbnail?.path +
                    '&filename=' + serviceSubjectQueue[serviceSubjectQueue.length - 1].thumbnail?.filename}}"
                        width="100%"
                        class="mb-3"
                        *ngIf="serviceSubjectQueue[serviceSubjectQueue.length - 1].thumbnail"
                      >
                      <div
                        *ngFor="let file of serviceSubjectQueue[serviceSubjectQueue.length - 1].attachments"
                        class="d-flex align-items-center mb-4"
                      >
                        <a
                          href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                          download="{{baseUrl + '/download?path=' + file.filename}}"
                          class="btn btn-primary btn-file"
                        >
                          <span class="fa {{getFontAwesomeIconFromMIME(file.mimeType)}}"></span>
                        </a>
                        <a
                          href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                          download="{{baseUrl + '/download?path=' + file.filename}}"
                        >
                          <div class="ms-2">
                            <p class="mb-0 text-break file-name">{{file.filename}}</p>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <div [innerHTML]="serviceSubjectQueue[serviceSubjectQueue.length - 1].description"></div>
                      <div *ngFor="let item of serviceSubjectQueue[serviceSubjectQueue.length - 1].serviceSubjectItems">
                        <button class="btn btn-subject"
                                [class.btn-active]="serviceSubjectItemActive === item"
                                (click)="serviceSubjectItemActive = item"
                                *ngIf="!item.parentId || ( !serviceSubjectQueue[serviceSubjectQueue.length - 1].isServiceSubject && item.parentId === serviceSubjectQueue[serviceSubjectQueue.length - 1].id)"
                        >
                          {{item.name}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </app-card>
            </div>
          </div>
        </section>
        <section *ngIf="step===3">

          <app-card [title]="'admin.service.request.view.more_details' | translate">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12 mb50">
                      <label for="message">{{"doctrine.service_subject.description" | translate}} *</label>
                      <textarea name="message" id="message" cols="30" rows="10" class="form-control" (ngModelChange)="formValidateCheck()"
                                #message="ngModel" [(ngModel)]="serviceRequest.message" required></textarea>
                      <div class="messages text-danger"
                           *ngIf="message.invalid && message.dirty && message.errors.required">
                        {{'errors.required'|translate}}
                      </div>
                    </div>
                    <div class="col-md-12">
                      <app-file-uploader
                        [(ngModel)]="serviceRequest.files"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="formValidateCheck()"
                        label="{{'admin.service_request.files' | translate}}"
                        description="{{'validators.image' | translate}}"
                        accept=".png,.gif,.jpg"
                        scope="dealer-system"
                        bupload="serviceRequest.files"
                        fieldName="files"
                        [queueLimit]="5"
                      ></app-file-uploader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </app-card>
        </section>
        <!--end second step-->
        <!--action button-->
        <div class="row justify-content-end">
          <div class="col-sm-1">
            <button class="btn btn-primary btn-block" [disabled]="step===1"
                    (click)="prev()">{{'global.prev' | translate}}</button>
          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary btn-block" *ngIf="step!==3"
                    [disabled]="
                  (
                    step === 1 &&
                    !selectedArticle
                  ) ||
                  (
                    step === 2 &&
                    (
                      (
                        serviceSubjectQueue.length > 0 &&
                        getVisibleServiceSubjectItems().length &&
                        serviceSubjectItemActive === undefined
                      ) || (
                        serviceSubjectQueue.length === 0 &&
                        serviceSubjectItemActive === undefined
                      )
                    )
                  )
"
                  (click)="next()">{{'global.next' | translate}}</button>
          <button class="btn btn-primary btn-block px-5" *ngIf="step===3" [disabled]="!formIsValidate" (click)="openConfirmation()" >{{'global.submit' | translate}}</button>
          </div>
        </div>
        <!--end action button-->
      </div>
    </form>
  </div>

  <div class="col-md-4 col-sm-12" *ngIf="order.reference">
    <div class="col-md-12">
      <app-card id="order_details" [title]="'admin.service_request.order.title'|translate">
        <div class="row">
          <div class="col-md-4">
            <p>{{'doctrine.attributes.order'|translate}}:</p>
            <p>{{'doctrine.order.reference'|translate}}:</p>
            <p>{{'doctrine.user.company'|translate}}:</p>
            <p>{{'doctrine.order.by'|translate}}:</p>
            <p>{{'doctrine.user.email'|translate}}:</p>
          </div>
          <div class="col-md-8">
            <p>{{order.orderNo}}</p>
            <p>{{order.reference}}</p>
            <p>{{order.user.companyName ? order.user.companyName : ''}}</p>
            <p>{{order.user.firstName}} {{order.user.lastName}}</p>
            <p>{{order.user.email}}</p>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>

<app-modal-basic #sendRequestModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.send_service_request_title' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="sendRequestModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.send_service_request_body' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            [disabled]="isSubmitting"
            (click)="storeServiceRequest()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>



